var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowVector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60191 9.72079L10.7172 5.67572C11.0943 5.30232 11.0943 4.69787 10.7172 4.32634L6.60191 0.278881C6.22108 -0.0938948 5.6057 -0.0920246 5.22614 0.278881C4.84974 0.65228 4.84974 1.25486 5.22614 1.62826L7.63406 3.99423L1.00944 3.99422C0.451448 3.99422 0 4.44069 0 4.9933C0 5.54591 0.451448 5.99237 1.00944 5.99237L7.64859 5.99239L5.22614 8.37083C4.84974 8.74361 4.84974 9.34681 5.22614 9.71959C5.60572 10.093 6.22109 10.0936 6.60191 9.72079Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowVector);
export default __webpack_public_path__ + "static/media/arrow-vector.0307c16474df075e6950218d41e8e9f0.svg";
export { ForwardRef as ReactComponent };